import React from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { getFavoriteProductTagsByFavoriteProductIdAction, createFavoriteProductTagAction } from '../../redux/actions/favoriteProductTagActions';
import TagAssignmentModal from '../common/tagAssignmentModal/TagAssignmentModal';

interface Props {
    visible: boolean;
    favoriteProductId?: number | null;
    onClose: () => void;
    onSaved?: () => void;
}

const FavoriteProductTagsModal: React.FC<Props> = ({ visible, favoriteProductId, onClose, onSaved }) => {
    const dispatch = useAppDispatch();
    const existingTags = useAppSelector((s) =>
        favoriteProductId ? s.favoriteProductTagReducer.byFavoriteProductId[favoriteProductId]?.tags ?? [] : []
    );
    const existingTagIds = existingTags.map((t) => t.tagId);

    return (
        <TagAssignmentModal
            visible={visible}
            existingTagIds={existingTagIds}
            onClose={onClose}
            onSaved={onSaved}
            onAssign={(tagId) => dispatch(createFavoriteProductTagAction({ favoriteProductId: favoriteProductId!, tagId })) as Promise<unknown>}
            onRefresh={() => favoriteProductId && dispatch(getFavoriteProductTagsByFavoriteProductIdAction(favoriteProductId))}
            inputId="add-tag-input"
        />
    );
};

export default FavoriteProductTagsModal;

